import React, { useEffect, useState, Fragment, Suspense, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { Trans, useTranslation } from "react-i18next";

import '@google/model-viewer/dist/model-viewer';

import { Button, IconButton } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";

import logo from '../../../../img/logo.svg';
import CubeIcon from "../../../icons/CubeIcon";

import apiClient from "../../../../services/api";
import store from "../../../../store";
import { toggleMessageOpen } from "../../../../store/actions/Message";
import { LoadingScreen } from "../../../partials/LoadingScreen";

function ProjectAR() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    
    const modelViewer = document.querySelector('model-viewer');

    const projectData = useSelector((state) => state.project.selectedProject);
    const usdzUrl = useSelector((state) => state.project.usdzUrl);

    const [name, setName] = useState();
    const [loading, setLoading] = useState(true);
    const [glbUrl, setGlbUrl] = useState(null);

    useEffect(() => {
        apiClient.post('/api/modules/check', {name: 'AR'}).then(response => {
            if(!response.data.success) {
                store.dispatch(toggleMessageOpen(t("You don't have permission to enter this page"), "error"))

                navigate('/app/home');
            } else {
                setLoading(false)
            }
        })
       setLoading(false);
    }, []);

    useEffect(() => {
        if(projectData) {
            if(projectData.model && projectData.model.gltf) {
                const model = projectData.model.gltf;
            }

            if(projectData.project) {
                setName(projectData.project.name);
            }

            if(projectData.model && projectData.model.usdz) {
                setGlbUrl(projectData.model.usdz);
            } else if (usdzUrl) {
                setGlbUrl(usdzUrl);
            }
        }
    }, [projectData]);

    /*
    const renderData = () => {
        return (
            <Fragment>
                <model-viewer
                    style={{width: '100%', height: '100%', margin: 'auto'}}
                    class="ModelViewer"
                    src={glbUrl}
                    alt={name}
                    poster={logo}
                    shadow-intensity="0"
                    camera-controls="camera-controls"
                    interaction-prompt-style="basic"
                    interaction-prompt-threshold={1000}
                    ar="ar"
                    ar-modes="scene-viewer quick-look"
                    auto-rotate
                    ar-scale="auto"
                    ar-placement="floor"
                    scale="0.01 0.01 0.01"
                    quick-look-browsers="safari chrome"
                >
                    <Button
                        onClick={() => {navigate('/app/project/view/'+projectData.project.id)}}
                        variant="contained"
                        startIcon={<ArrowBack />}
                        style={{
                            position: 'absolute',
                            top: '25px',
                            right: '16px'
                        }}
                    >
                        <Trans>Back</Trans>
                    </Button>
                    <IconButton
                        slot="ar-button"
                        variant="outlined"
                        style={{
                            position: 'absolute',
                            bottom: '16%',
                            left: '16px'
                        }}
                    >
                        <CubeIcon />
                    </IconButton>
                </model-viewer>
            </Fragment>
        )
    }
    */

    function getMobileOperatingSystem() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }
    
        if (/android/i.test(userAgent)) {
            return "Android";
        }
    
        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }
    
        return "unknown";
    }

    const iframeRef = useRef();

    const ModelViewer = () => {
        useEffect(() => {
            if(!glbUrl) {
                return;
            }

            const iframeDoc = iframeRef?.current?.contentDocument || iframeRef?.current?.contentWindow.document;
            iframeDoc.open();

            const device = getMobileOperatingSystem();
            let arMode = 'scene-viewer quick-look';

            if(device == 'Android') {
                arMode = 'webxr';
            }

            iframeDoc.write(`
                <!DOCTYPE html>
                <html lang="en">
                    <head>
                    <meta charset="UTF-8">
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <title>GLB Viewer</title>
                    <script type="module" src="https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js"></script>
                    </head>
                    <body>
                        <model-viewer
                            id='modelViewer'
                            class="ModelViewer"
                            src="`+glbUrl+`"
                            alt="`+name+`"
                            poster="`+logo+`"
                            alt="A 3D model"
                            shadow-intensity="0"
                            camera-controls="camera-controls"
                            interaction-prompt-style="basic"
                            interaction-prompt-threshold={1000}
                            ar
                            ar-modes="`+arMode+`"
                            ar-scale="auto"
                            ar-placement="floor"
                            scale="0.01 0.01 0.01"
                            quick-look-browsers="safari chrome"
                            style="width: 100%; height: 90vh;"
                        >
                        </model-viewer>
                    </body>
                </html>
            `);
        iframeDoc.close();
        }, [glbUrl]);

        return (
            <>
                <iframe
                    ref={iframeRef}
                    style={{
                        width: "100%",
                        height: "100%",
                        border: "none"
                    }}
                    >
                </iframe>
                <Button
                    onClick={() => {navigate('/app/project/view/'+projectData.project.id)}}
                    variant="contained"
                    startIcon={<ArrowBack />}
                    style={{
                        position: 'absolute',
                        top: '25px',
                        right: '16px'
                    }}
                >
                    <Trans>Back</Trans>
                </Button>
            </>
        );
    }

    return ( !loading ? <ModelViewer /> : <LoadingScreen /> );
}

export default ProjectAR;
